import React from 'react'

const LINKS = [
  {
    title: 'Bericht Juni 2017',
    subtitle: 'Auftaktwochenende',
    url: 'http://erinnerte-zukunft.de/berichte/Bericht_Juni_2017.pdf'
  },
  {
    title: '06. 2017 ١تقریر ندوة',
    subtitle: 'الندوة الافتتاحیة',
    url: 'http://erinnerte-zukunft.de/berichte/Bericht_Juni_2017_arabisch.pdf'
  },
  {
    title: 'Bericht August 2017',
    subtitle: 'Religionen in Berlin',
    url: 'http://erinnerte-zukunft.de/berichte/Bericht_August_2017.pdf'
  },
  {
    title: '08. 2017 ١تقریر ندوة',
    subtitle: 'الأدیان في برلین',
    url: 'http://erinnerte-zukunft.de/berichte/Bericht_August_2017_arabisch.pdf'
  },
  {
    title: 'Bericht Oktober 2017',
    subtitle: 'Religionen im Nahen Osten',
    url: 'http://erinnerte-zukunft.de/berichte/Bericht_Oktober_2017.pdf'
  },
  {
    title: '10. 2017 ١تقریر ندوة',
    subtitle: 'أدیان الشرق الأوسط',
    url:
      'http://erinnerte-zukunft.de/berichte/Bericht_Oktober_2017_arabisch.pdf'
  },
  {
    title: 'Bericht März 2018',
    subtitle: 'Zwei Besuche und Abschluss',
    url: 'http://erinnerte-zukunft.de/berichte/Bericht_Maerz_2018.pdf'
  },
  {
    title: '3. 2018 ١تقریر ندوة',
    subtitle: 'زيارتان و الختام',
    url: 'http://erinnerte-zukunft.de/berichte/Bericht_Maerz_2018_arabisch.pdf'
  },
  {
    title: 'English Report 2017-2018',
    subtitle: 'Preserving the Contiguity of Religions in the Near East',
    url: 'http://erinnerte-zukunft.de/berichte/Report_Recalled_Future.pdf'
  },
  {
    title: 'Résumée en français 2017-2018',
    subtitle: 'Préserver la contiguïté des religions au Proche Orient',
    url: 'http://erinnerte-zukunft.de/berichte/Resumee_en_francais.pdf'
  }
]

export default function Reports() {
  return (
    <section id="reports" className="reports reports--background">
      {LINKS.map((entry, i) => {
        return (
          <div className="reports-entry" key={i}>
            <div
              className="reports-entry-title"
              dangerouslySetInnerHTML={{ __html: entry.title }}
            />
            <div className="reports-entry-subtitle">{entry.subtitle}</div>
            <a className="reports-entry-link" href={entry.url}>
              Lesen
            </a>
            <hr className="reports-entry-seperator" />
          </div>
        )
      })}
    </section>
  )
}



/** WEBPACK FOOTER **
 ** ./src/components/reports.js
 **/